import { createAuthClient } from "better-auth/react";
import { multiSessionClient, twoFactorClient } from "better-auth/client/plugins";

const baseURL =
  process.env.REACT_APP_API_URL || "http://localhost:3000";

export const authClient = createAuthClient({
  baseURL,
  fetchOptions: { credentials: "include" },
  plugins: [
    // Account switcher: hold multiple signed-in accounts in one browser.
    // Exposes authClient.multiSession.{listDeviceSessions,setActive,revoke}.
    multiSessionClient(),
    // Two-factor (feature #19). When a 2FA-enabled user signs in, the client
    // redirects to /two-factor to collect their TOTP code. Exposes
    // authClient.twoFactor.{enable,disable,verifyTotp,getTotpUri,...}.
    twoFactorClient({
      onTwoFactorRedirect() {
        window.location.assign("/two-factor");
      },
    }),
  ],
});

export const {
  signUp,
  signIn,
  signOut,
  useSession,
  getSession,
  changePassword,
  changeEmail,
  updateUser,
  twoFactor,
} = authClient;
